import React from 'react'
import update from 'immutability-helper'

import { browserHistory } from 'react-router'

class Proyectos extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: 'lista-proyectos'
        }
    }

    rederigir(e) {
        e.preventDefault()

        let id = e.target.id

        if (id === 'lista-proyectos') {
            browserHistory.push('/proyectos')
        } else if (id === 'nuevo-proyecto') {
            browserHistory.push('/proyectos/nuevo-proyecto')
        }

        this.setState(update(this.state, {
            tab: { $set: id }
        }))
    }

    render() {
        let childs = this.props.children
            && React.cloneElement(this.props.children)

        return (
            <div className='config'>
                <ul className='nav justify-content-center'>
                    <li id='lista-proyectos' className={this.state.tab === 'lista-proyectos' ? 'nav-item active' : 'nav-item'} onClick={this.rederigir.bind(this)}>
                        <a id='lista-proyectos' className='nav-link' onClick={this.rederigir.bind(this)}>TUS PROYECTOS</a>
                    </li>
                    <li id='nuevo-proyecto' className={this.state.tab === 'nuevo-proyecto' ? 'nav-item active' : 'nav-item'} onClick={this.rederigir.bind(this)}>
                        <a id='nuevo-proyecto' className='nav-link' onClick={this.rederigir.bind(this)}>NUEVO PROYECTO</a>
                    </li>
                </ul>
                {childs}
            </div>
        )
    }
}

export default Proyectos